import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Soft%20elegant%20lifestyle%20photography%20with%20draped%20neutral%20toned%20fabric%20and%20curated%20fashion%20accessories%20on%20clean%20cream%20surface%20warm%20golden%20hour%20ambient%20light%20gentle%20shadows%20sophisticated%20editorial%20shopping%20aesthetic&width=1600&height=600&seq=cta-bg-v2-01&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-background-50/85" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
          Ready to Discover Amazing Products?
        </h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto mb-8 leading-relaxed">
          Join thousands of smart shoppers using the Kakobuy Spreadsheet to find quality products faster. Browse categories, compare prices, and shop with confidence.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
          >
            Vigorbuy Spreadsheet &mdash; Buy It Now
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 bg-background-50 border border-background-300/70 hover:border-foreground-400 px-8 py-3.5 rounded-full text-sm font-semibold text-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Explore Main Platform
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}